import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'web-ui-components/lib/organisms/modals';
import { Container } from 'web-ui-components/lib/global/layout';
import Prompt from './Prompt';
import Processed from './Processed';
import NoPayments from './NoPayments';
import withContent from '../../containers/withContent';
import { declineContent, cancelContent, contentPropTypes } from './Decline.content';
import { getMyPaymentsToAuthoriseCount, getOtherUserPaymentsToAuthoriseCount } from '../../states/payments/builders';
import { UPDATE_VERIFICATION_STATUS_SUCCESS, goToAccounts } from '../../states/page/actions';

const mapState = (state) => ({
	myPaymentsToAuthoriseCount: getMyPaymentsToAuthoriseCount(state),
	otherUserPaymentsToAuthoriseCount: getOtherUserPaymentsToAuthoriseCount(state),
});

const mapDispatch = (dispatch) => ({
	goToAccountsPage: () => dispatch(goToAccounts()),
});

class Decline extends Component {
	constructor(props) {
		super(props);
		this.state = {
			step: 'prompt',
		};

		this.onConfirm = this.onConfirm.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}

	onConfirm() {
		this.props.handleConfirm().then((response) => {
			if (response.type === UPDATE_VERIFICATION_STATUS_SUCCESS) {
				this.setState({ step: 'processed' });
				this.props.refresh();
			}
		});
	}

	handleClose() {
		const { myPaymentsToAuthoriseCount, otherUserPaymentsToAuthoriseCount } = this.props;
		const { step } = this.state;

		if (!myPaymentsToAuthoriseCount && !otherUserPaymentsToAuthoriseCount && step === 'processed') {
			this.setState({ step: 'nopayments' });
			return;
		}
		this.props.handleClose();
	}

	render() {
		const { content, goToAccountsPage, handleCancelPrompt } = this.props;
		const steps = {
			prompt: <Prompt onClose={handleCancelPrompt || this.handleClose} onConfirm={this.onConfirm} {...content} />,
			processed: <Processed onClose={this.handleClose} {...content} />,
			nopayments: <NoPayments onClose={this.handleClose} goToAccounts={goToAccountsPage} {...content} />,
		};

		return (
			<Modal size="md" isOpen>
				<Container className="modal__container">{steps[this.state.step]}</Container>
			</Modal>
		);
	}
}

Decline.propTypes = {
	handleClose: PropTypes.func.isRequired,
	handleConfirm: PropTypes.func.isRequired,
	handleCancelPrompt: PropTypes.func,
	content: PropTypes.shape(contentPropTypes),
	refresh: PropTypes.func,
	myPaymentsToAuthoriseCount: PropTypes.number.isRequired,
	otherUserPaymentsToAuthoriseCount: PropTypes.number.isRequired,
	goToAccountsPage: PropTypes.func.isRequired,
};

Decline.defaultProps = {
	refresh: () => {},
};

export default connect(mapState, mapDispatch)(withContent({ content: declineContent })(Decline));
export const ConnectWrapper = connect(mapState, mapDispatch)(Decline);

export const Cancel = connect(mapState, mapDispatch)(withContent({ content: cancelContent })(Decline));
